"use strict";

var find = require("./find.js");

var go1 = require("./go1.js");

var isUndefined = require("./isUndefined.js");

const none = (f, iter) => go1(find(f, iter), isUndefined);

module.exports = none;